import { render, staticRenderFns } from "./formCustomPage.vue?vue&type=template&id=482eeb5c&scoped=true&"
import script from "./formCustomPage.vue?vue&type=script&lang=js&"
export * from "./formCustomPage.vue?vue&type=script&lang=js&"
import style0 from "./formCustomPage.vue?vue&type=style&index=0&id=482eeb5c&lang=scss&scoped=true&"
import style1 from "./formCustomPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482eeb5c",
  null
  
)

export default component.exports